import APIService from "./apiService";

class CompanyService extends APIService {
  constructor() {
    super(process.env.REACT_APP_API_BASEURL)
  }

  async createCompany(data) {
    return this.post('/company/create', data)
      .then((response) => {
        return response?.data
      })
      .catch((error) => {
        throw error?.response?.data
      })
  }

  async getAllCompanies() {
    return this.get('/company')
      .then((response) => {
        return response?.data
      })
      .catch((error) => {
        throw error?.response?.data
      })
  }

  async getCompanyById(companyId) {
    return this.get(`/company/${companyId}`)
      .then((response) => {
        return response?.data
      })
      .catch((error) => {
        throw error?.response?.data
      })
  }

  async deleteCompany(companyId) {
    return this.request({
      method: 'delete',
      url: this.baseURL + `/company/${companyId}`,
      // headers: this.getAccessToken() ? this.getHeaders() : {},
    })
      .then((response) => {
        console.log(response)
        console.log(response?.data)
        return response?.data
      })
      .catch((error) => {
        throw error?.response?.data
      })
  }

  async patchCompany(companyId, data) {
    return this.request({
      method: 'put',
      url: this.baseURL + `/company/${companyId}`,
      data,
      // headers: this.getAccessToken() ? this.getHeaders() : {},
    })
      .then((response) => {
        console.log(response)
        console.log(response?.data)
        return response?.data
      })
      .catch((error) => {
        throw error?.response?.data
      })
  }
}

const companyService = new CompanyService()
export default companyService
